import type { ApiResponse, PaginationQuery, SearchQuery, SongDto } from '@lyricshub/shared';
import { api } from './api';

export interface SongDetailDto extends SongDto {
  artist: { id: string; name: string; slug: string };
  album: { id: string; title: string; slug: string; coverUrl: string | null } | null;
  genre: { id: string; name: string; slug: string } | null;
  language: { id: string; code: string; name: string } | null;
  releaseYear: number | null;
  isLiked?: boolean;
}

export const songsService = {
  async getSongs(params?: PaginationQuery): Promise<ApiResponse<SongDto[]>> {
    const response = await api.get('/songs', { params });
    return response.data;
  },

  async getTrending(): Promise<ApiResponse<SongDto[]>> {
    const response = await api.get('/songs/trending');
    return response.data;
  },

  async getRecent(): Promise<ApiResponse<SongDto[]>> {
    const response = await api.get('/songs/recent');
    return response.data;
  },

  async search(params: SearchQuery): Promise<ApiResponse<SongDto[]>> {
    const response = await api.get('/songs/search', { params });
    return response.data;
  },

  async getSongBySlug(slug: string): Promise<ApiResponse<SongDetailDto>> {
    const response = await api.get(`/songs/${slug}`);
    return response.data;
  },

  async getRelated(songId: string): Promise<ApiResponse<SongDto[]>> {
    const response = await api.get(`/songs/${songId}/related`);
    return response.data;
  },

  async registerView(songId: string): Promise<ApiResponse<void>> {
    const response = await api.post(`/songs/${songId}/view`);
    return response.data;
  },

  async likeSong(songId: string): Promise<ApiResponse<void>> {
    const response = await api.post(`/songs/${songId}/like`);
    return response.data;
  },

  async unlikeSong(songId: string): Promise<ApiResponse<void>> {
    const response = await api.delete(`/songs/${songId}/like`);
    return response.data;
  },

  async getWeeklyCharts(): Promise<ApiResponse<SongDto[]>> {
    const response = await api.get('/songs/charts/weekly');
    return response.data;
  },

  async getMonthlyCharts(): Promise<ApiResponse<SongDto[]>> {
    const response = await api.get('/songs/charts/monthly');
    return response.data;
  },
};
